export function FirstLetterToUpperCase(targetWord: string) {
  return targetWord.charAt(0).toUpperCase() + targetWord.slice(1);
}
